// extracted by mini-css-extract-plugin
module.exports = {"reactivateBanner":"ReactivateSubscriptionBanner_reactivateBanner__2oL9q","bannerText":"ReactivateSubscriptionBanner_bannerText__6fcGe"};